module.exports = __webpack_public_path__ + "static/media/sort_by.a6cbdefc.svg";